import { render, staticRenderFns } from "./MobibInput.vue?vue&type=template&id=12ebbeef&scoped=true"
import script from "./MobibInput.vue?vue&type=script&lang=js"
export * from "./MobibInput.vue?vue&type=script&lang=js"
import style0 from "./MobibInput.vue?vue&type=style&index=0&id=12ebbeef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ebbeef",
  null
  
)

export default component.exports